import { combineReducers } from 'redux';

import notifications from './notifications.reducer';
import profile from './profile.reducer';
import { InfoReducer } from '../../actions/InfoActions';
import { DemographicReducer } from '../../common/actions/DemographicActions';
import { IntegrationReducer } from '../../actions/IntegrationActions';
import LanguageSlice from '../../common/slices/LanguageSlice';
import UserSlice from '../../common/slices/UserSlice';
import RegistrationSlice from '../../common/slices/RegistrationSlice';

export default combineReducers({
    notifications,
    profile,
    info: InfoReducer,
    demographics: DemographicReducer,
    integration: IntegrationReducer,
    language: LanguageSlice.reducer,
    user: UserSlice.reducer,
    auth: combineReducers({ registration: RegistrationSlice.reducer }),
});
